import React from "react"
import {Modal, Button} from "antd"
import {Link} from "react-router-dom"

export default function LeaveSurveyModal({open, onClose}) {
  return (
    <Modal
      title="Opravdu chcete dotazník opustit?"
      width={550}
      centered
      closable={false}
      className="leave-survey-modal"
      open={open}
      onCancel={onClose}
      footer={[
        <Link
          key="leave"
          type="button"
          className="ant-btn ant-btn-primary"
          to="/"
          onClick={onClose}
        >
          <span>Opustit dotazník</span>
        </Link>,
        <Button
          key="continue"
          type="secondary"
          onClick={onClose}
        >
          Pokračovat v dotazníku
        </Button>,
      ]}
    >
      <p>Jeho opuštěním se dosavadní odpovědi neuloží.</p>
      <p>Při první návštěvě je nutné tyto informace vyplnit na místě.</p>
    </Modal>
  )
}